export default "__VITE_ASSET__CnZsetrK__"